import React from 'react';
import styled from 'styled-components';
import PersianNumber from 'packages/ui/PersianNumber';
import { Field } from 'formik';
import { FormControl, FormGroup, Label } from 'components/form/Formik';
import RichTextField from 'packages/ui/RichTextField';

const Footer = styled('div')`
  color: #555;
  padding: 10px 15px;
`;

const Counter = styled('div')`
  margin-bottom: 10px;
`;

const HelpWrapper = styled('div')`
  background-color: #f5f5f5;
  border-radius: 3px;

  ul {
    list-style: disc;
    margin: 5px 20px 5px 0;
  }
`;

const Help = sms => {
  return (
    <Footer>
      {sms && (
        <Counter>
          (<PersianNumber value={sms.length} format /> کاراکتر)
        </Counter>
      )}
      <HelpWrapper>
        <span>می‌توانید از عبارت‌های خاص زیر هم استفاده کنید:</span>
        <ul>
          <li>
            <strong>_FULL_NAME_BOLD_</strong> (برای ایمیل)
          </li>
          <li>
            <strong>_FULL_NAME_</strong>
          </li>
          <li>
            <strong>_FULL_NAME_LIMITED_</strong>
          </li>
          <li>
            <strong>_FIRST_NAME_</strong>
          </li>
          <li>
            <strong>_LAST_NAME_</strong>
          </li>
          <li>
            <strong>_EVENT_SHORT_LINK_</strong> کوتاه شده لینک رویداد همراه با utm و کد تخفیف (برای
            پیامک)
          </li>
          {/* <li>
            <strong>_UNSUBSCRIPTION_GUIDE_</strong> متن راهنمای لغو اشتراک (برای پیامک)
          </li> */}
        </ul>
        مثلا اگه بخواید هرجا بنویسه "حسین بقایی گرامی" باید "_FULL_NAME_ گرامی" بنویسید.
      </HelpWrapper>
    </Footer>
  );
};

const chanelLabel = {
  sms: 'پیامک',
  email: 'ایمیل',
  bale: 'بله'
};

function DescriptionInput({ values, setFieldValue }) {
  return [
    <div key="description">
      <FormGroup>
        <Label htmlFor="description">متن {chanelLabel[values.channel]}</Label>
        <FormControl>
          {values.channel !== 'email' ? (
            <Field
              name={`${values.channel === 'sms' ? 'description_sms' : 'description'}`}
              value={values.channel === 'sms' ? values.description_sms : values.description}
              as="textarea"
              rows={6}
              cols={50}
            />
          ) : (
            <RichTextField
              id="description"
              name="description"
              value={values.channel === 'sms' ? values.description_sms : values.description}
              onEditorChange={content =>
                setFieldValue(values.channel === 'sms' ? 'description_sms' : 'description', content)
              }
            />
          )}
        </FormControl>
      </FormGroup>
    </div>,
    <Help key="help" sms={values.desction_sms} />
  ];
}

export default DescriptionInput;
